/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFooterFragment, FooterFragment, FullFooterFragment} from '@amblique/contentful/app/contentful/fragments/footer';

/**
 * Get a single Footer by ID (base - scalars only)
 */
export const getBaseFooterById = gql`
  ${BaseFooterFragment}

  query GetBaseFooterById($id: String!, $locale: String!, $preview: Boolean) {
    footer(id: $id, locale: $locale, preview: $preview) {
      ...BaseFooterFragment
    }
  }
`;

/**
 * Get a single Footer by ID (standard - 1 level deep)
 */
export const getFooterById = gql`
  ${FooterFragment}

  query GetFooterById($id: String!, $locale: String!, $preview: Boolean) {
    footer(id: $id, locale: $locale, preview: $preview) {
      ...FooterFragment
    }
  }
`;

/**
 * Get a single Footer by ID (full - 2 levels deep)
 */
export const getFullFooterById = gql`
  ${FullFooterFragment}

  query GetFullFooterById($id: String!, $locale: String!, $preview: Boolean) {
    footer(id: $id, locale: $locale, preview: $preview) {
      ...FullFooterFragment
    }
  }
`;

/**
 * Get all Footer entries with pagination (base - scalars only)
 */
export const getBaseFooters = gql`
  ${BaseFooterFragment}

  query GetBaseFooters(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterOrder]
    $where: FooterFilter
    $preview: Boolean
  ) {
    footerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFooterFragment
      }
    }
  }
`;

/**
 * Get all Footer entries with pagination (standard - 1 level deep)
 */
export const getFooters = gql`
  ${FooterFragment}

  query GetFooters(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterOrder]
    $where: FooterFilter
    $preview: Boolean
  ) {
    footerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FooterFragment
      }
    }
  }
`;

/**
 * Get all Footer entries with pagination (full - 2 levels deep)
 */
export const getFullFooters = gql`
  ${FullFooterFragment}

  query GetFullFooters(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterOrder]
    $where: FooterFilter
    $preview: Boolean
  ) {
    footerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFooterFragment
      }
    }
  }
`;
